import { Link } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";
import type { Lang } from "@/i18n";
import { path } from "@/lib/site";

/** Fixed rotating circular sticker — always-visible CTA. */
export function StickerFab({ lang, label }: { lang: Lang; label: string }) {
  // Build the rotating text from the label, repeated to fill the circle
  const text = `${label} · ${label} · `;

  return (
    <Link
      to={path(lang, "contact")}
      aria-label={label}
      className="sticker-fab group hidden sm:block"
    >
      <div className="relative h-full w-full">
        {/* Rotating outer text */}
        <svg
          viewBox="0 0 200 200"
          className="absolute inset-0 h-full w-full rotate-slow text-foreground"
        >
          <defs>
            <path
              id="sticker-circle"
              d="M 100,100 m -82,0 a 82,82 0 1,1 164,0 a 82,82 0 1,1 -164,0"
            />
          </defs>
          <text
            fill="currentColor"
            style={{
              fontFamily: "Urbanist, system-ui, sans-serif",
              fontWeight: 800,
              fontSize: "18px",
              letterSpacing: "0.18em",
              textTransform: "uppercase",
            }}
          >
            <textPath href="#sticker-circle" startOffset="0">
              {text}
            </textPath>
          </text>
        </svg>
        {/* Inner blaze disc */}
        <div className="absolute inset-[18%] flex items-center justify-center rounded-full bg-blaze border-[1.5px] border-foreground transition-transform group-hover:scale-110">
          <ArrowUpRight size={28} strokeWidth={2.5} className="text-foreground" />
        </div>
      </div>
    </Link>
  );
}
